export const DEFAULT_LIMITS = {
  title: 60, description_min: 10, description_max: 300, max_entries: 20, text: 1000, attachments: 3,
}

// A `[...]` placeholder; a markdown link/image `[label](url)` is not one (same rule as the backend).
export const hasPlaceholder = (text) => /\[[^[\]]*\](?!\()/.test(text || '')

// Why a text cannot be enabled, or null.
export const enableBlocker = (text) => {
  if (!(text || '').trim()) return 'empty_text'
  if (hasPlaceholder(text)) return 'placeholder_text'
  return null
}

export const emptyDraft = () => ({ id: null, enabled: false, title: '', description: '', text: '', attachments: [] })

export const draftFromEntry = (entry) => ({
  id: entry.id,
  enabled: Boolean(entry.enabled),
  title: entry.title || '',
  description: entry.description || '',
  text: entry.text || '',
  attachments: entry.attachments || [],
})

export const isDirty = (draft, saved) => JSON.stringify(draft) !== JSON.stringify(saved)

// Field problems the form can see before calling the API: field -> error code.
export const draftProblems = (draft, limits = DEFAULT_LIMITS) => {
  const problems = {}
  const title = draft.title.trim()
  const description = draft.description.trim()
  if (!title) problems.title = 'required'
  else if (title.length > limits.title) problems.title = 'too_long'
  if (!description) problems.description = 'required'
  else if (description.length < limits.description_min) problems.description = 'too_short'
  else if (description.length > limits.description_max) problems.description = 'too_long'
  if (draft.text.length > limits.text) problems.text = 'too_long'
  return problems
}

// What the customer receives, in the order the backend sends it: the text, one `name: link` line
// per file, then the images. The stored url stands in for the backend's download link.
export const previewParts = (draft) => {
  const attachments = draft.attachments || []
  const files = attachments.filter((a) => a.type === 'file' && a.url)
  const images = attachments.filter((a) => a.type === 'image' && a.url)
  const text = (draft.text || '').trim()
  return {
    text: text ? [text, ...files.map((a) => (a.filename ? `${a.filename}: ${a.url}` : a.url))].join('\n') : '',
    images,
  }
}

// Which entry a deep link (`#id` or `?entry=id`) names, or ''.
export const entryIdFromLocation = (location) => {
  const hash = (location.hash || '').replace(/^#/, '')
  if (hash) return hash
  return new URLSearchParams(location.search || '').get('entry') || ''
}

const dotted = (ext) => (ext.startsWith('.') ? ext : `.${ext}`)
export const acceptFor = (extensions) => (extensions || []).map(dotted).join(',')
